import { Box } from '@cdl/heartbeat-react';
import { line } from 'd3-shape';
import React from 'react';
import { SECOND } from '../../utils/time';
import { useStrip } from '../hooks/useStrip';
import { GRID_MV, GRID_UNIT_SIZE } from '../utils/graph.utils';
import { getExtent } from '../utils/scale';

interface Props {
  render?: boolean;
}

export const Calibration: React.FC<Props> = ({ render = true }) => {
  const { yScale, xScale, height } = useStrip();

  const duration = getExtent(xScale.domain());
  const topStep = 4 * SECOND;
  const bottomStep = (duration - topStep) / 2;

  const ranges: [number, number][] = [
    [0, 0],
    [bottomStep, 0],
    [bottomStep, -GRID_MV],
    [bottomStep + topStep, -GRID_MV],
    [bottomStep + topStep, 0],
    [2 * bottomStep + topStep, 0],
  ];

  const calibrationTransform = line()
    .x(([x]) => xScale(x))
    .y(([_, y]) => yScale(y));

  const calibrationPath = calibrationTransform(ranges) || undefined;

  return (
    <g
      className='calibration'
      transform={`translate(0, ${height / 2 - GRID_UNIT_SIZE})`}
    >
      <Box
        as='path'
        className='calibration-lead'
        d={render ? calibrationPath : undefined}
        fill='none'
        stroke='neutral.900'
        strokeWidth={GRID_UNIT_SIZE}
      />
    </g>
  );
};
